import { API_BASE } from './apiBase';
const API_BASE_URL = API_BASE;

// Fonction utilitaire pour obtenir les headers avec authentification
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = {};
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

// Fonction utilitaire pour les requêtes HTTP
const makeRequest = async (url, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
        ...options.headers
      },
      ...options
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Erreur réseau' }));
      throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Erreur API:', error);
    throw error;
  }
};

// Récupérer tous les avoirs
export const getAvoirs = async () => {
  try {
    const response = await makeRequest('/avoirs', {
      method: 'GET'
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Erreur lors de la récupération des avoirs:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Récupérer un avoir spécifique
export const getAvoir = async (id) => {
  try {
    const response = await makeRequest(`/avoirs/${id}`, {
      method: 'GET'
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error(`Erreur lors de la récupération de l'avoir ${id}:`, error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Récupérer l'avoir d'une facture spécifique
export const getAvoirByFacture = async (factureId) => {
  try {
    const response = await makeRequest(`/avoirs/facture/${factureId}`, {
      method: 'GET'
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error(`Erreur lors de la récupération de l'avoir pour la facture ${factureId}:`, error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Créer un avoir
export const creerAvoir = async (factureId, raison, notes = null) => {
  try {
    const response = await makeRequest('/avoirs', {
      method: 'POST',
      body: JSON.stringify({
        facture_id: factureId,
        raison: raison,
        notes: notes
      })
    });
    
    console.log('✅ Avoir créé avec succès:', response.data);
    return response;
  } catch (error) {
    console.error('❌ Erreur lors de la création de l\'avoir:', error);
    throw error;
  }
};

// Mettre à jour un avoir
export const updateAvoir = async (id, data) => {
  try {
    const response = await makeRequest(`/avoirs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return {
      success: true,
      data: response.data,
      message: response.message
    };
  } catch (error) {
    console.error(`Erreur lors de la mise à jour de l'avoir ${id}:`, error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default {
  getAvoirs,
  getAvoir,
  getAvoirByFacture,
  creerAvoir,
  updateAvoir
};
